(() => {
  const root = document.querySelector('.faq-page');
  if (!root || root.dataset.accordionReady || !Element.prototype.animate) return;
  root.dataset.accordionReady = 'true';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const states = [...root.querySelectorAll('.faq-item')].map((item) => ({
    item,
    summary: item.querySelector('summary'),
    panel: item.querySelector('.faq-answer-wrap'),
    expanded: item.open,
    animation: null,
  }));

  const finish = (state) => {
    if (state.animation) {
      state.animation.onfinish = null;
      state.animation.cancel();
      state.animation = null;
    }
    state.item.open = state.expanded;
    state.panel.style.removeProperty('height');
    state.item.dataset.state = state.expanded ? 'open' : 'closed';
  };

  const setExpanded = (state, expanded) => {
    // Capture the current rendered height before cancelling an interrupted
    // animation, so rapid clicks reverse smoothly from the visible position.
    const startHeight = state.item.open ? state.panel.getBoundingClientRect().height : 0;
    if (state.animation) {
      state.animation.onfinish = null;
      state.animation.cancel();
      state.animation = null;
    }

    state.expanded = expanded;
    state.summary.setAttribute('aria-expanded', String(expanded));
    state.panel.inert = !expanded;
    state.panel.setAttribute('aria-hidden', String(!expanded));
    state.item.dataset.state = expanded ? 'opening' : 'closing';
    if (expanded) state.item.open = true;

    // Measure natural height, including wrapped text and panel spacing.
    // Never use a fixed max-height: answers vary across screen sizes.
    state.panel.style.height = 'auto';
    const endHeight = expanded ? state.panel.getBoundingClientRect().height : 0;
    state.panel.style.height = `${startHeight}px`;

    if (reducedMotion.matches || Math.abs(endHeight - startHeight) < 1) {
      finish(state);
      return;
    }

    state.animation = state.panel.animate(
      [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
      {
        duration: expanded ? 520 : 360,
        easing: 'cubic-bezier(0.18, 0.9, 0.22, 1)',
        fill: 'both',
      },
    );
    state.animation.onfinish = () => finish(state);
  };

  states.forEach((state) => {
    // Native grouping would instantly hide the previous answer before its
    // closing animation. Manage exclusivity here; no-JS keeps native details.
    state.item.removeAttribute('name');
    state.summary.setAttribute('aria-expanded', String(state.expanded));
    state.panel.inert = !state.expanded;
    state.panel.setAttribute('aria-hidden', String(!state.expanded));
    state.item.dataset.state = state.expanded ? 'open' : 'closed';
    state.summary.addEventListener('click', (event) => {
      event.preventDefault();
      const expanded = !state.expanded;
      if (expanded) {
        states.forEach((other) => {
          if (other !== state && other.expanded) setExpanded(other, false);
        });
      }
      setExpanded(state, expanded);
    });
  });

  // Restore intrinsic height if wrapping changes mid-animation, and honor
  // reduced-motion changes without leaving an answer clipped or stuck.
  const finishRunning = () => states.forEach((state) => {
    if (state.animation) finish(state);
  });
  window.addEventListener('resize', finishRunning);
  reducedMotion.addEventListener('change', finishRunning);
})();
